import { useEffect, useState } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';

export const useKeyboardOpenState = (): boolean => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return () => {};

    // Remove only our own listeners on cleanup.
    const listeners = [
      Keyboard.addListener('keyboardDidShow', () => setIsKeyboardOpen(true)),
      Keyboard.addListener('keyboardDidHide', () => setIsKeyboardOpen(false)),
    ];

    return () => {
      listeners.forEach((listener) => {
        listener.then((handle) => handle.remove());
      });
    };
  }, []);

  return isKeyboardOpen;
};
